module.exports = __webpack_public_path__ + "static/img/Logo.1a22272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo.png
// module id = keSl
// module chunks = 1